import { Box } from "@mui/material";
import { CollapsedBox } from "../../ui/collapsed-box";
import { TextFieldStr } from "../../ui/text-field";
import { usePlannerContext } from "../../../services/context/planner-context";
import { CheckboxPlanner } from "../../ui/checkbox-planner";
import { useUserContext } from "../../../services/context/user-context";

export const Infrastructure = ({ area, nodeId }) => {
  const { setNodes } = usePlannerContext();
  const { viewOnly } = useUserContext();
  const formValues = area.building;

  const handleValueChange = (value, name) => {
    setNodes((nodes) =>
      nodes.map((node) => {
        if (node.id === nodeId) {
          return {
            ...node,
            data: {
              ...node.data,
              building: {
                ...node.data.building,
                [name]: value,
              },
            },
          };
        }
        return node;
      })
    );
  };

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        gap: "16px",
        mt: "16px",
      }}
    >
      <Box
        sx={{
          width: "100%",
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "space-between",
          gap: "16px",
        }}
      >
        <TextFieldStr
          label={"Min. Area"}
          unit="m²"
          placeholder="mandatory"
          name="rangeMin"
          requier={true}
          value={formValues.rangeMin}
          setValue={handleValueChange}
          area={area}
          shouldBeInteger={true}
          disabled={viewOnly}
        />

        <TextFieldStr
          label={"Max. Area"}
          unit="m²"
          placeholder="optional"
          name="rangeMax"
          value={formValues.rangeMax}
          setValue={handleValueChange}
          area={area}
          shouldBeInteger={true}
          disabled={viewOnly}
        />
      </Box>

      <CollapsedBox height={170 /* 240 */}>
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            gap: "16px",
          }}
        >
          <TextFieldStr
            label={"Max. Building Height"}
            unit="m"
            placeholder="optional"
            name="height"
            value={formValues.height}
            setValue={handleValueChange}
            area={area}
            disabled={viewOnly}
          />

          <TextFieldStr
            label={"Cost per m²GFA"}
            unit="€/m²GFA"
            placeholder="optional"
            name="cost"
            value={formValues.cost}
            setValue={handleValueChange}
            area={area}
            disabled={viewOnly}
          />

          <CheckboxPlanner
            label={"Isolated"}
            value={formValues.isolated}
            setValue={handleValueChange}
            name="isolated"
            area={area}
            disabled={viewOnly}
          />
        </Box>
      </CollapsedBox>
    </Box>
  );
};
